import {
  GET_CLOUDWATCH_LOGS,
  GET_CLOUDWATCH_STREAM,
} from "src/actions/cloudWatchLogs.actions";

const initialState = {
  logs: [],
  streams: [],
  loading: false,
  error: null
};

export const cloudWatchLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLOUDWATCH_LOGS.REQUEST:
    case GET_CLOUDWATCH_STREAM.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_CLOUDWATCH_LOGS.SUCCESS:
      return {
        ...state,
        logs: action.payload,
        loading: false
      };
    case GET_CLOUDWATCH_STREAM.SUCCESS:
      return {
        ...state,
        streams: action.payload,
        loading: false
      };
    case GET_CLOUDWATCH_LOGS.FAILURE:
    case GET_CLOUDWATCH_STREAM.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
